<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="cont" epub:type="toc" role="doc-toc">
<header>
<h1 class="FMH" id="cont"><span aria-label="3" id="pg_3" role="doc-pagebreak"><samp class="SANS_Tiva_Regular_17">Contents</samp></span></h1>
</header>
<ol class="toc">
<li class="CCT"><a href="#/xhtml/introduction">Introduction</a></li>
<li class="CPT1"><a href="#/xhtml/chapter1"><span class="Funkydori_Regular_17">Getting Started</span></a></li>
<li class="CCT"><a href="#/xhtml/chapter1#ch1">Basic Equipment</a></li>
<li class="CCT"><a href="#/xhtml/chapter2">The Sewing Machine</a></li>
<li class="CCT"><a href="#/xhtml/chapter3">Using Patterns</a></li>
<li class="CCT"><a href="#/xhtml/chapter4">Modifying Patterns</a></li>
<li class="CCT"><a href="#/xhtml/chapter5">Understanding Patterns</a></li>
<li class="CCT"><a href="#/xhtml/chapter6">Fabric Types</a></li>
<li class="CCT"><a href="#/xhtml/chapter7">Fabric Preparation and Cutting</a></li>
<li class="CPT1"><span href="#/xhtml/chapter8" title="Link target outside of Sample"><span class="Funkydori_Regular_17">Techniques</span></span></li>
<li class="CCT"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Flush Zip Pocket</span></li>
<li class="CCT"><span href="#/xhtml/chapter9" title="Link target outside of Sample">Top Edge Zip</span></li>
<li class="CCT"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Slimline Concealed Top Edge Zip</span></li>
<li class="CCT"><span href="#/xhtml/chapter11" title="Link target outside of Sample">Magnetic Snaps</span></li>
<li class="CCT"><span href="#/xhtml/chapter12" title="Link target outside of Sample">Open-End Straps</span></li>
<li class="CCT"><span href="#/xhtml/chapter13" title="Link target outside of Sample">Closed-End Straps</span></li>
<li class="CCT"><span href="#/xhtml/chapter14" title="Link target outside of Sample">Adjustable Straps</span></li>
<li class="CCT"><span href="#/xhtml/chapter15" title="Link target outside of Sample">Bound Edges</span></li>
<li class="CCT"><span href="#/xhtml/chapter16" title="Link target outside of Sample">Piped Edges</span></li>
<li class="CCT"><span href="#/xhtml/chapter17" title="Link target outside of Sample">Inserting Linings: Pull Through and Turn Out Method</span></li>
<li class="CPT"><span href="#/xhtml/part1" title="Link target outside of Sample"><span class="Funkydori_Regular_17">Projects</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter18" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The Geek-Chic iPad Case</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter19" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The Compact Groceries Tote</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter20" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The Access-All-Areas Pouch</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter21" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The Toddler-Friendly Backpack</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter22" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The ‘Too Cool for School’ Satchel</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter23" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The Pleated Purse-Frame Purse</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter24" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The All-Sorted Laundry Bag</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter25" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The Fashionista Baby Bag</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter28" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The Double-Pannier Bicycle Bag</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter29" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The 3-in-1 Convertible Backpack</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter30" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The Terrific Tri-Fold Wallet</span></span></li>
<li class="CCT1"><span href="#/xhtml/chapter31" title="Link target outside of Sample"><span class="Funkydori_Regular_17">The Train-Style Vanity Case</span></span></li>
<li class="CCT-TOP"><span href="#/xhtml/suppliers" title="Link target outside of Sample">Suppliers</span></li>
<li class="CCT"><span href="#/xhtml/resources" title="Link target outside of Sample">Resources</span></li>
<li class="CCT"><span href="#/xhtml/pattern" title="Link target outside of Sample">Pattern Legend</span></li>
<li class="CCT"><span href="#/xhtml/abouttheauthor" title="Link target outside of Sample">About the Author</span></li>
<li class="CCT"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample">Acknowledgements</span></li>
</ol>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7670f4d8